export default {
  'YouTube and High Definition Videos': 'YouTube dan Video Definisi Tinggi',
  'Story videos (Instagram/Snaps/TikTok)': 'Video story (Instagram/Snaps/TikTok)',
  'Facebook and Instagram Feed videos': 'Video Feed Facebook dan Instagram',
  'Facebook and Twitter Portrait Videos': 'Video Potret Facebook dan Twitter',
  'Twitter and Facebbok Landscape Videos': 'Video Lanskap Twitter dan Facebook',
  'Facebook Cover Videos And Blog Banners': 'Video Sampul Facebook dan Banner Blog',
  'Fit': 'Cocokkan',
  'Fill': 'Isikan',
}